import $ from 'jquery';
import _ from 'underscore';
import Slider from 'blocks/slider/slider';
import Soon from 'portlets/site/main/soon/soon';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaMain',
			dom: {
				slider: '.js-main-slider',
				banner: '.js-main-banner',
				button: '.js-main-button'
			},
			template: {
				button: '.js-main-button-template'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		const self = this;
		self.$button = $(self.options.dom.button);
		self.$buttonTmpl = $(self.options.template.button);
		self.buttonTmpl = _.template(self.$buttonTmpl.html().trim());
		self.$slider = self.$el.find(self.options.dom.slider);

		// self.$soon = self.$el.find(self.options.dom.soon);
		return self;
	}

	openSoon(event) {
		const self = this;
		const $target = $(event.currentTarget);
		const type = $target.data('js');
		if (yotaPortlets.region.products[type] === true) {
			event.preventDefault();
			self.soon.open(type);
		}
		return self;
	}

	build() {
		const self = this;
		self.$button.each(function () {
			const $button = $(this);
			const type = $button.data('type');
			let text = 'От ' + yotaPortlets.region.products[type] + ' <span class="b-rur">p</span>/мес.';
			text = 'Подробнее';
			if (yotaPortlets.region.products[type] === false) {
				text = 'Подробнее';
			}
			if (yotaPortlets.region.products[type] === true) {
				text = 'Предзаказ';
			}

			$button.html(self.buttonTmpl({text}));
		});
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.build();

			self.slider = new Slider({
				el: self.$slider,
				time: 5000
			}).render();
			self.soon = new Soon().render();
			self.$el.on('click', self.options.dom.banner, self.openSoon.bind(self));
		}
		return self;
	}
}


// import $ from 'jquery';
// import _ from 'underscore';
// import Slider from 'blocks/slider/slider';
// import Soon from 'portlets/site/main/soon/soon';

// export default class {
// 	constructor(options) {
// 		const defaults = {
// 			el: '#yotaMainLayout',
// 			dom: {
// 				main: '#yotaMain',
// 				mainTmpl: '#yotaMainTmpl',
// 				roamingTmpl: '#yotaMainRoamingTmpl',
// 				soonTmpl: '#yotaMainSoonTmpl',
// 				regionTmpl: '#yotaMainRegionTmpl',
// 				slider: '.js-main-slider',
// 				soon: '.js-main-soon-open'
// 			}
// 		};

// 		this.options = $.extend(true, {}, defaults, options);
// 		this.$el = $(this.options.el);
// 		return this;
// 	}

// 	build() {
// 		const self = this;
// 		let html = false;

// 		if (self.data.products.roaming === true) {
// 			html = self.roamingTmpl();
// 		} else if (self.data.products.voice === true && self.data.products.tablet === true && self.data.products.modem === true) {
// 			html = self.soonTmpl();
// 		} else if (self.data.products.voice === false && self.data.products.tablet === false && self.data.products.modem === false) {
// 			html = self.regionTmpl();
// 		} else if (self.data.products.isMoscow !== true) {
// 			html = self.mainTmpl(self.data.products);
// 		}

// 		if (html !== false) {
// 			html = html
// 				.split('{TMPL{').join('{{')
// 				.split('}TMPL}').join('}}')
// 				.split('{script}').join('<script')
// 				.split('{/script}').join('</script>');

// 			self.$el.html(html);
// 		}
// 		return self;
// 	}

// 	getBaseDom() {
// 		const self = this;
// 		self.$main = self.$el.find(self.options.dom.main);

// 		self.$mainTmpl = $(self.options.dom.mainTmpl);
// 		this.mainTmpl = _.template(this.$mainTmpl.html().trim());

// 		self.$roamingTmpl = $(self.options.dom.roamingTmpl);
// 		this.roamingTmpl = _.template(this.$roamingTmpl.html().trim());

// 		self.$soonTmpl = $(self.options.dom.soonTmpl);
// 		this.soonTmpl = _.template(this.$soonTmpl.html().trim());

// 		self.$regionTmpl = $(self.options.dom.regionTmpl);
// 		this.regionTmpl = _.template(this.$regionTmpl.html().trim());
// 		return self;
// 	}

// 	getDom() {
// 		const self = this;
// 		self.$slider = self.$el.find(self.options.dom.slider);
// 		self.$soon = self.$el.find(self.options.dom.soon);
// 		return self;
// 	}

// 	openSoon(event) {
// 		const self = this;
// 		const $target = $(event.currentTarget);
// 		const type = $target.data('js');
// 		self.soon.open(type);
// 		return self;
// 	}

// 	render() {
// 		const self = this;
// 		if (self.$el.length) {
// 			if (yotaPortlets.region) {
// 				self.data = yotaPortlets.region;

// 				self
// 					.getBaseDom()
// 					.build()
// 					.getDom();

// 				self.slider = new Slider({
// 					el: self.$slider,
// 					time: 5000
// 				}).render();

// 				if (self.$soon.length) {
// 					self.soon = new Soon().render();

// 					self.$soon.on('click', self.openSoon.bind(self));
// 				}
// 			} else {
// 				console.error('The yotaMain portlet has no data, set data to "yotaPortlets.region"');
// 			}
// 		}
// 		return self;
// 	}
// }



// WEBPACK FOOTER //
// ./app/portlets/site/main/main.js